import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { logApiError, EMPTY_RESULTS } from '../utils/errorHandler'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL + '/api'

export function fetchReview(id) {
    return Vue.axios.get('/reviews/' + id).then((resp => resp.data.data)).catch((error) => {
        if(error.response.status == 404){
            return null;
        }
        return null;
    });
}

export function fetchReviews(page) {
    return Vue.axios.get('/reviews?page=' + page ).then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchReviews:', error.message);
        return { data: [], meta: { pagination: {} } };
    })
}

export function fetchIndustryNews(page) {
    return Vue.axios.get('/industry-news/?page=' + page ).then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchIndustryNews:', error.message);
        return { data: [], meta: { pagination: {} } };
    })
} //fetchArticle

export function fetchIndustryNewsArticle(slug) {
    return Vue.axios.get('/industry-news/' + slug ).then((resp => resp.data)).catch((error) => {
        if(error.response.status == 404){
            return null;
        }
        return null;
    });
}


export function fetchPost(id) {
    return Vue.axios.get('/news/' + id).then((resp => resp.data.data)).catch((error) => {
        console.error('API Error in fetchPost:', error.message);
        return null;
    })
}

export function fetchNews() {
    return Vue.axios.get('/news').then((resp => resp.data.data)).catch((error) => {
        console.error('API Error in fetchNews:', error.message);
        return [];
    })
}

export function fetchMakes() {
    return Vue.axios.get('/ad-makes').then((resp => resp.data.data)).catch((error) => {
        console.error('API Error in fetchMakes:', error.message);
        return [];
    })
}

export function fetchMakeReviews(make) {
    return Vue.axios.get('/ad-makes/' + make + '/reviews').then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchMakeReviews:', error.message);
        return { data: [], meta: { pagination: {} } };
    })
}

export function fetchReviewMakes() {
    return Vue.axios.get('/review-make-list').then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchReviewMakes:', error.message);
        return [];
    })
}

export function fetchAd(payload) {
    return Vue.axios.get('/listings/' + payload.slug).then((resp => resp.data.data)).catch((error) => {
        // Only log non-404 errors to reduce noise from old/invalid URLs
        if (!error.response || error.response.status !== 404) {
            console.error('API Error in fetchAd:', error.message);
        }
        return error;
    })
}

export async function fetchDealer(slug) {
    let url = slug.split('&')[0];
    url = url.split('/')[0];
    return await Vue.axios.get('/dealer/' + url).then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchDealer:', error.message);
        return null;
    })
}

export async function fetchDealerReviews(slug) {
    let url = slug.split('&')[0];
    url = url.split('/')[0];
    return await Vue.axios.get('/dealer/' + url + '/reviews').then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchDealerReviews:', error.message);
        return { data: [], meta: { pagination: {} } };
    })
}

export async function fetchSearchMasterResults(url) {
    return await Vue.axios.get(url).then((resp => resp)).catch((error) => {
        logApiError(error, 'fetchSearchMasterResults');
        return {
            data: {
                data: EMPTY_RESULTS.search
            }
        };
    })
}

export async function fetchSearchResults(url) {
    return await Vue.axios.get(url).then((resp => resp.data.data)).catch((error) => {
        logApiError(error, 'fetchSearchResults');
        return EMPTY_RESULTS.search;
    })
}

export async function fetchMakeModelBySlug(url){
    return await Vue.axios.get(url).then((resp => resp.data)).catch((error) => {
        console.error('API Error in fetchMakeModelBySlug:', error.message);
        return { make: null, model: null };
    })
}
